/* eslint-disable @typescript-eslint/no-explicit-any */
import { forwardRef, useImperativeHandle } from "react";

export interface SummaryRef {
  getHtml: () => string;
  getFullHtml: () => string;
}

interface CoverSectionProps {
  company_name: string;
  date: string;
  responsible_manager_name: string;
  company_website: string;
  client_contact_name: string;
  responsible_manager_title: string;
  client_name: string;
  client_contact_title: string;
  index: number; // Add index prop for page numbering
  companyLogo: string;
}

const SignatureSection = forwardRef<SummaryRef, CoverSectionProps>(
  (
    {
      company_name,
      date,
      responsible_manager_name,
      company_website,
      client_contact_name,
      responsible_manager_title,
      client_name,
      client_contact_title,
      index,
      companyLogo,
    },
    ref
  ) => {
    useImperativeHandle(ref, () => ({
      getHtml: () => {
        return `
        <div class="last_page">
        <div class="header">
          <div class="proposal_title">
            <div class="page_counter"> 0${index} </div>
            <h4 style="margin-left: 24px;"> Signatures </h4>
          </div>
        <div class="logo_container">
          ${
            companyLogo
              ? `<img src="${companyLogo}" class="temp_logo" alt="logo" />`
              : `<img src="/images/company/no_image_grey.png" class="temp_logo" alt="logo"/>`
          }
          </div>
        </div>
        <div class="content">
          <p style="margin-bottom: 40px; color: #000;">
            By signing below, the Client and Contractor acknowledge that they
            have read, understand, and agree to be bound by all terms and
            conditions contained in this Proposal and any attachments hereto.
            This Proposal becomes effective as of the date of the last signature
            below.
          </p>
          <div style="display: flex; gap: 10px;">
            <div class="left" style="margin-right: 250px;">
              <div style="text-align: left; width: 100%; font-size: 11px;">
                By <br />
                ${company_name}
              </div>
              <div class="signatureBox"> </div>
              <div style="text-align: left; width: 100%;">
                <h6 style="font-size: 16px; line-height: 24px; font-weight: 400; margin-bottom: 16px; margin-top: 0px;">
                  ${responsible_manager_name}
                  <br />
                  ${responsible_manager_title}
                </h6>
                <h6 style="font-size: 16px; line-height: 24px; font-weight: 400; margin-bottom: 0px; margin-top: 0px;">
                  Date: ${date}
                </h6>
              </div>
            </div>
            <div class="right">
              <div style="text-align: left; width: 100%;">
                Accepted by <br />
                <div>${client_name}</div>
              </div>
              <div style="text-align: left; width: 100%;">
                <div class="signatureBox">
                  
                </div>
                <div class="pageFooter">
                  <h6>${
                    company_website ? company_website : "evergreen.com"
                  }</h6>
                  <h6> 14 </h6>
                </div>
                <h6>
                  ${client_contact_name ? client_contact_name : "Shayan"} <br />
                  ${client_contact_title}
                </h6>
                <h6 style="font-size: 16px; line-height: 24px; font-weight: 400; margin-bottom: 0px; margin-top: 0px;">
                  Date: ${date}
                </h6>
              </div>
            </div>
          </div>
        </div>
        <div class="pageFooter">
          <h6>${company_website ? company_website : "evergreen.com"}</h6>
          <h6> 14 </h6>
        </div>
      </div>
      `;
      },
      getFullHtml: () => {
        return `<div class="last_page signature_page">
        <div class="header">
          <div class="proposal_title main_title">
            <div class="page_counter"> 0${index} </div>
            <h4 style="margin-left: 24px;"> Signatures </h4>
          </div>
        <div class="logo_container">
          ${
            companyLogo
              ? `<img src="${companyLogo}" class="temp_logo" alt="logo" />`
              : `<img src="/images/company/no_image_grey.png" class="temp_logo" alt="logo"/>`
          }
          </div>
        </div>
        <div class="content">
          <p style="margin-bottom: 40px; color: #000;">
            By signing below, the Client and Contractor acknowledge that they
            have read, understand, and agree to be bound by all terms and
            conditions contained in this Proposal and any attachments hereto.
            This Proposal becomes effective as of the date of the last signature
            below.
          </p>
          <div style="display: flex; gap: 10px;">
            <div class="left">
              <div style="text-align: left; width: 100%; font-size: 11px;"> 
                By <br />
                <span style="font-weight: 700;"> ${company_name} </span>
              </div>
              <div class="signatureBox"> </div>
              <div style="text-align: left; width: 100%;">
                <h6 style="font-size: 16px; line-height: 24px; font-weight: 400; margin-bottom: 16px; margin-top: 0px;">
                  ${responsible_manager_name}
                  <br />
                  ${responsible_manager_title}
                </h6>
                <h6 style="font-size: 16px; line-height: 24px; font-weight: 400; margin-bottom: 0px; margin-top: 0px;">
                  Date: ${date}
                </h6>
              </div>
            </div>
            <div class="right">
              <div class="accepted_by">
                Accepted by <br />
                <span style="font-weight: 700;"> ${client_name} </span>
                
              </div>
              <div class="signature_details">
                <div class="signatureBox">
                <img alt="signature" src="'<%= signed_url %>'" />
                </div>
                <h6 style="margin-bottom: 16px;">
                  ${client_contact_name} <br />
                  ${client_contact_title}
                </h6>
                <h6>
                  Date: ${date}
                </h6>
              </div>
            </div>
          </div>
        </div>
        <div class="pageFooter">
          <h6>${company_website}</h6>
        </div>
      </div>`;
      },
    }));
    return (
      <div className="last_page">
        <div className="header">
          <div className="proposal_title">
            <div className="page_counter"> 0{index} </div>
            <h4 style={{ marginLeft: "24px" }}> Signatures </h4>
          </div>
          <div className="logo_container">
            {companyLogo ? (
              <img
                src={companyLogo}
                className="temp_logo"
                alt="template logo"
              />
            ) : (
              <img
                src="/images/company/no_image_grey.png"
                className="temp_logo"
                alt="logo"
              />
            )}
          </div>
        </div>
        <div className="content">
          <p style={{ marginBottom: "40px", color: "#000" }}>
            By signing below, the Client and Contractor acknowledge that they
            have read, understand, and agree to be bound by all terms and
            conditions contained in this Proposal and any attachments hereto.
            This Proposal becomes effective as of the date of the last signature
            below.
          </p>
          <div style={{ display: "flex", gap: "10px" }}>
            <div className="left">
              <div
                style={{ textAlign: "left", width: "100%", fontSize: "11px" }}
              >
                By <br />
                <span style={{ fontWeight: "700" }}> {company_name} </span>
              </div>
              <div className="signatureBox"> </div>
              <div style={{ textAlign: "left", width: "100%" }}>
                <h6
                  style={{
                    fontSize: "11px",
                    lineHeight: "24px",
                    fontWeight: 400,
                    marginBottom: "0px",
                    marginTop: "0px",
                    color: "#000",
                  }}
                >
                  {responsible_manager_name}
                </h6>
                <h6
                  style={{
                    fontSize: "10px",
                    fontWeight: 400,
                    marginBottom: "16px",
                    marginTop: "0px",
                    color: "#000",
                  }}
                >
                  {responsible_manager_title}
                </h6>
                <h6
                  style={{
                    fontSize: "11px",
                    lineHeight: "24px",
                    fontWeight: 400,
                    marginBottom: "0px",
                    marginTop: "0px",
                    color: "#000",
                  }}
                >
                  Date: {date}
                </h6>
              </div>
            </div>

            <div className="right">
              <div
                style={{ textAlign: "left", width: "100%", fontSize: "11px" }}
              >
                By <br />
                <span style={{ fontWeight: "700" }}> {company_name} </span>
              </div>
              <div className="signatureBox"> </div>
              <div style={{ textAlign: "left", width: "100%" }}>
                <h6
                  style={{
                    fontSize: "11px",
                    lineHeight: "24px",
                    fontWeight: 400,
                    marginBottom: "0px",
                    marginTop: "0px",
                    color: "#000",
                  }}
                >
                  {client_contact_name ? client_contact_name : "Anwer"}
                </h6>
                <h6
                  style={{
                    fontSize: "10px",
                    fontWeight: 400,
                    marginBottom: "16px",
                    marginTop: "0px",
                    color: "#000",
                  }}
                >
                  {client_contact_title}{" "}
                </h6>
                <h6
                  style={{
                    fontSize: "11px",
                    lineHeight: "24px",
                    fontWeight: 400,
                    marginBottom: "0px",
                    marginTop: "0px",
                    color: "#000",
                  }}
                >
                  Date: {date}
                </h6>
              </div>
            </div>
          </div>
        </div>
        <div className="pageFooter">
          <h6>{company_website ? company_website : "evergreen.com"}</h6>
          {/* <h6> 14 </h6> */}
        </div>
      </div>
    );
  }
);

export default SignatureSection;
